import { gql } from "@apollo/client";

export const MAINTAIN_FEED_COMPONENTS_INFO = gql`
  mutation PanelMaintainFeedComponents($domain: String!, $maintainFeedComponents: [FeedComponentInfoInput!]!) {
    panelMaintainFeedComponents(domain: $domain, maintainFeedComponents: $maintainFeedComponents) {
      success
      updatedValues {
        id
        name
        readyMixture
        priority
        ds
        energy
        protein
        deleted
      }
    }
  }`;

